import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useUrlSearchParams } from 'use-url-search-params';
import { Card, Button, OverlayTrigger, Form, Tooltip } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { Badge } from 'reactstrap';
import CsLineIcons from '../../../cs-line-icons/CsLineIcons';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import Pagination from '@vlsergey/react-bootstrap-pagination';
import { SORTING_ORDER } from '../../../constants/index';
import moment from 'moment';
import axios from 'axios';
import UserAuthKey from '../../../components/Common/UserAuthKey';
import { setUserData } from '../../../Redux/user/userSlice';
import { FINANCE_ROLE_ID, SHOW_ROOM_MANAGER_ROLE_ID, CUSTOMER_CARE_MANAGER_ROLE_ID, CUSTOMER_CARE_SUPERVISOR_ROLE_ID, STORE_CUSTOMER_CARE_SUPERVISOR_ROLE_ID } from '../../../constants/roles'; // Import the role constants
import { updateRefundStatus,generateCreditNoteToken } from '../StoreRefunds/actions/action';

import {
  Table,
  Row,
  Col,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Spinner,
} from 'reactstrap';
import BankInfo from './BankInfo';
import ReactDrawer from 'react-drawer';
import 'react-drawer/lib/react-drawer.css';
import DHPagination from '../../../components/Pagination';
import FilterSearchQueue from '../../../components/FilterSearch/FilterSearchQueue';

import './BankRefundList.css';
import { color } from 'echarts/lib/export';
import { fetchStoreRefundsList } from '../StoreRefunds/actions/action';
import ManageStoreRefundExport from '../StoreRefunds/components/ManageStoreRefundExport';

const StoreRefundList = (props) => {
  const { stores } = props;
  const location = useLocation();
  const [btnprimary, setBtnprimary] = useState(false);
  const dispatch = useDispatch();
  const [copiedId, setCopiedId] = useState(null);
  const [sortingName, setSortingName] = useState({ id: 'sort.date_asc' });
  const [paginationValue, setPaginationValue] = useUrlSearchParams({ page: 0 });
  const [limitValue, setLimitValue] = useUrlSearchParams({ limit: 10 });
  const [sortingValue, setSortingValue] = useUrlSearchParams({
    sort: '_date',
    order: SORTING_ORDER.ASC,
  });
  const [searchValue, setSearchValue] = useUrlSearchParams({ search: '' });
  const [customActiveTab, setcustomActiveTab] = useState('All');
  let is_split = 0;
  const { country = [] } = useSelector((state) => state.country);
  let currentCountry = localStorage.getItem('WEBSITE_COUNTRY');
  const splitVal = location?.pathname.split('/');
  const [advancedFilter, setAdvancedFilter] = useState({});
  const [searchFilter, setSearchFilter] = useUrlSearchParams({ search: '' });
  const [statusFilter, setStatusFilter] = useUrlSearchParams({ status: 'All' });

  
  const fetchStoreRefundList = useCallback(async (data) => {
    try {
      setDataLoading(true);
      await fetchStoreRefundsList({
        params: data,
        dispatch,
      }); // send data directly, not { params: data }
    } catch (error) {
      setDataLoading(false);
      console.error('Error fetching orders:', error);
    } finally {
      setDataLoading(false);
    }
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      const data = {
        start: Number(paginationValue.page * limitValue.limit),
        limit: Number(limitValue.limit),
        sort: { value: sortingValue.sort, order: Number(sortingValue.order) },
        search_qry: searchValue.search,
        status: customActiveTab,
        orderBy: 'id',
        country: currentCountry,
        advancedFilter,
        stores,
        store_id: UserStore,
      };
      fetchStoreRefundList(data);
    }, 300);
    return () => clearTimeout(delay);
  }, [
    paginationValue.page,
    limitValue,
    advancedFilter,
    searchFilter,
    statusFilter,
    stores,
  ]);

  const { refundList = [], isLoading } = useSelector((state) => state.refund);

  const [isDataLoading, setDataLoading] = useState(false);

  const { listOrders } = refundList;
  const refundData = listOrders?.orderList;

  let UserRoleID = '';
  let UserCountry = '';
  let UserStore = '';
  if (localStorage.getItem('authUser')) {
    const userObj = JSON.parse(localStorage.getItem('authUser'));
    if (userObj?.role_id !== undefined) {
      UserRoleID = userObj?.role_id;
      UserCountry = userObj?.country;
      UserStore = userObj?.stores;
      console.log('UserRoleID:', userObj);
    }
  }

  let pageIndex = Number(listOrders?.start);

  const [viewMode, setViewMode] = useState(false);

  const customStyles = `
  .refundOrder .react-drawer-drawer {
    width: ${viewMode ? '50%' : ''} !important;
  }
`;

    // State for approve confirmation modal
  const [approveModal, setApproveModal] = useState({ open: false, order: null });

  // Approve refund handler (replace with actual logic)
  const handleApproveRefund = async () => {
    setDataLoading(true);
    if (!approveModal.order) return;
    try {
      await updateRefundStatus({
        refund_id: approveModal?.order?.id || approveModal?.order?.RefundId || approveModal?.order?.refund_id,
        status: 'approved',
        dispatch,
      });
      toast.success('Refund approved!');
      setApproveModal({ open: false, order: null });
      // Optionally reload list
      // fetchStoreRefundList({
      //   start: Number(paginationValue.page * limitValue.limit),
      //   limit: Number(limitValue.limit),
      //   sort: { value: sortingValue.sort, order: Number(sortingValue.order) },
      //   search_qry: searchValue.search,
      //   status: customActiveTab,
      //   orderBy: 'id',
      //   country: currentCountry,
      //   advancedFilter,
      //   stores,
      // });
        const data = {
        start: Number(paginationValue.page * limitValue.limit),
        limit: Number(limitValue.limit),
        sort: { value: sortingValue.sort, order: Number(sortingValue.order) },
        search_qry: searchValue.search,
        status: customActiveTab,
        orderBy: 'id',
        country: currentCountry,
        advancedFilter,
        stores,
        store_id: UserStore,
      };
      fetchStoreRefundList(data);
    } catch (error) {
      toast.error('Failed to approve refund.');
    }
    finally {
      setDataLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearchValue({ search: e.target.value });
  };

  const generateToken = async (id) => {
      try {
        const response = await generateCreditNoteToken({
          params: { refund_id: id },
        });
        console.log(response.data)
        const downlaodUrl = `${process.env.REACT_APP_OMS_WEBAPI}v1/credit-note/get?token=${response?.data?.token || response?.data}`;
        window.location.href = downlaodUrl;
      } catch (error) {
        console.error('Error downloading PDF:', error);
      }
    };
  return (
    <>
      <>
        <style>{customStyles}</style>
        <Row>
          <Col xl={12}>
             <Row>
              <Col>
                <ManageStoreRefundExport />
              </Col>
              <Col xl={2} md={6} className="mb-3 ">
                <div className="searchBox">
                  <div className="d-inline-block float-md-start me-1 mb-1 search-input-container w-100 bg-foreground">
                    <Form.Control
                      type="text"
                      placeholder="Search"
                      value={searchValue.search}
                      id="listSearch"
                      onChange={handleSearch}
                    />
                    <span className="search-magnifier-icon searchIcon">
                      <CsLineIcons icon="search" />
                    </span>
                    <span className="search-delete-icon d-none">
                      <CsLineIcons icon="close" />
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
            <>
              <div className=" dt-table">
                <div className="table-responsive">
                  <Table className="OrderListTable table mb-0">
                    <thead>
                      <tr>
                         <th>SI.No</th>
                      <th nowrap="nowrap">Date</th>
                      <th nowrap="nowrap">Reference No</th>
                      <th nowrap="nowrap">Payment Mode</th>
                      <th nowrap="nowrap">Refund Amount</th>
                      <th nowrap="nowrap">Country</th>
                      <th>Status</th>
                      <th nowrap="nowrap">Store</th>
                      <th nowrap="nowrap">Action</th>
                      </tr>
                    </thead>
                    {isLoading || isDataLoading ? (
                      <>
                        <Spinner className="ms-2 sploader" color="primary" />
                        <tbody>
                          {[...Array(2)].map((_, index) => (
                            <tr>
                              <td>
                                <p className="placeholder-glow">
                                  <span className="placeholder col-2"></span>
                                </p>
                              </td>
                              <td>
                                <p className="placeholder-glow">
                                  <span className="placeholder col-12"></span>
                                  <span className="placeholder col-6"></span>
                                  <span
                                    className="placeholder"
                                    style={{ width: '25%' }}
                                  ></span>
                                  <span className="placeholder w-75"></span>
                                </p>
                              </td>
                              <td>
                                {' '}
                                <p className="placeholder-glow d-flex flex-column gap-1">
                                  <span className="placeholder col-6"></span>
                                </p>
                              </td>
                              <td>
                                {' '}
                                <p className="placeholder-glow">
                                  <span className="placeholder col-6"></span>
                                </p>
                              </td>
                              <td>
                                {' '}
                                <p className="placeholder-glow">
                                  <span className="placeholder col-6"></span>
                                </p>
                              </td>
                              <td>
                                {' '}
                                <p className="placeholder-glow">
                                  <span className="placeholder col-6"></span>
                                </p>
                              </td>
                              <td>
                                <p className="placeholder-glow">
                                  <span className="placeholder col-6"></span>
                                  <span
                                    className="placeholder"
                                    style={{ width: '25%' }}
                                  ></span>
                                </p>
                              </td>
                              <td colSpan={2}></td>
                            </tr>
                          ))}
                        </tbody>
                      </>
                    ) : refundData?.length > 0 ? (
                      <>
                        {(refundData || []).map((order, index) => {
                          pageIndex++;
                          let cdate = order.Date,
                            orderDt = moment(new Date(cdate)).format(
                              'Do MMM, YYYY'
                            ),
                            orderTime = moment(new Date(cdate)).format(
                              'h:mm:ss a'
                            );
                            return (
                            <tbody key={index}>
                              <tr>
                              <th scope="row">{pageIndex}</th>
                              <td>
                                <span className="fs-12">
                                {orderDt}
                                </span>
                                <p className="fs-12">
                                {orderTime}
                                </p>
                              </td>
                              <td className="ReturnInfo1">
                                {order?.OrderId}
                                
                              </td>
                              <td>
                                {order?.paymentMode}
                                {order?.refundId && (
                                <p className="fs-12">
                                  Credit Note: {order.refundId}
                                </p>
                                )}
                          
                            </td>

                            <td>{order?.currency} <strong className='fs-6'>{order?.RefundAmount}</strong>
                            </td>
                            <td>{order?.country}
                            </td>
                            <td>
                              {order?.status === 'pending' && (
                              <span className="badge bg-warning text-dark">
                                Pending
                              </span>
                              )}
                              {order?.status === 'approved' && (
                              <span className="badge bg-success text-white">
                                Approved
                              </span>
                              )}
                            </td>
                            <td>{order?.store_id || '-'}</td>
                            <td>
                              <div className="action-flex-container">
                               
                              {['pending'].includes(String(order?.status)) && (
                                <>
                                <span
                                  className="btn btn-sm btn-outline-success waves-effect waves-light"
                                  title="Approve Refund"
                                  onClick={() => {
                                    setApproveModal({ open: true, order });
                                    }}
                                  >
                                    <i className="mdi mdi-check"></i> Approve
                                  </span>
                                  </>
                                )}

                                  {/* Approve Confirmation Modal */}
                                  {approveModal.open && (
                                  <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                                    <div className="modal-dialog modal-dialog-centered">
                                    <div className="modal-content">
                                      <div className="modal-header">
                                      <h5 className="modal-title">Are you sure?</h5>
                                      <button type="button" className="btn-close" aria-label="Close" onClick={() => setApproveModal({ open: false, order: null })}></button>
                                      </div>
                                      <div className="modal-body">
                                      <p>Are you sure you refunded the amount?</p>
                                      </div>
                                      <div className="modal-footer">
                                      <button type="button" className="btn btn-secondary" onClick={() => setApproveModal({ open: false, order: null })}>Cancel</button>
                                      <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={handleApproveRefund}
                                        disabled={isDataLoading}
                                      >
                                        {isDataLoading ? 'Processing...' : 'Confirm'}
                                      </button>
                                      </div>
                                    </div>
                                    </div>
                                  </div>
                                  )}
                                  <span
                                  className="btn btn-sm btn-outline-warning waves-effect waves-light"
                                  title="View Bank Info"
                                  onClick={() => {
                                    // Open the new page with the required URL
                                    if (order?.return_id && order?.OrderId) {
                                    window.open(`/returnorders/${order.return_id}/${order.OrderId}`, '_blank');
                                    }
                                  }}
                                  >
                                  <i className="mdi mdi-eye-outline"></i>
                                  </span>
                                   {/* Credit Note PDF Button */}
                                          {order?.refundId && order?.status === 'approved' && (
                                            <button
                                            type="button"
                                            className="btn btn-sm btn-outline-info ms-1"
                                            title="View Credit Note PDF"
                                             onClick={() => generateToken(order?.refundId)}
                                          >
                                             <i className="mdi mdi-download"></i> 
                                          </button>
                                        )}
                                </div>
                                 
                              </td>
                              </tr>
                            </tbody>
                            );
                        })}
                      </>
                    ) : (
                      <>
                        <tbody>
                          <tr>
                            <td colSpan={10}>No Records found</td>
                          </tr>
                        </tbody>
                      </>
                    )}
                  </Table>
                </div>
                {refundData?.length > 0 ? (
                  <DHPagination
                    totalPages={listOrders?.recordsTotal}
                    currentPage={paginationValue.page}
                    setPaginationValue={setPaginationValue}
                    setLimitValue={setLimitValue}
                  />
                ) : null}
              </div>
            </>
          </Col>
        </Row>
      </>
    </>
  );
};

export default StoreRefundList;
